<script setup lang="ts">
import { RouterView } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { useSessionTimeout } from '@/composables/useSessionTimeout'
import { SessionTimeoutWarning } from '@/components/ui'
import { onMounted, watch } from 'vue'

const authStore = useAuthStore()
const sessionTimeout = useSessionTimeout()

onMounted(() => {
  // Initialize auth state from storage
  authStore.initializeFromStorage()

  // Fetch current user if authenticated
  if (authStore.isAuthenticated) {
    authStore.fetchCurrentUser()
    // Start session timeout monitoring
    sessionTimeout.startSessionTimeout()
  }
})

// Watch for authentication changes
watch(
  () => authStore.isAuthenticated,
  (isAuthenticated) => {
    if (isAuthenticated) {
      sessionTimeout.startSessionTimeout()
    } else {
      sessionTimeout.stopSessionTimeout()
    }
  },
)

// Handle session extension
const handleExtendSession = () => {
  sessionTimeout.extendSession()
}

// Handle manual logout from warning dialog
const handleWarningLogout = () => {
  sessionTimeout.stopSessionTimeout()
}
</script>

<template>
  <div id="app" class="min-h-screen bg-gray-50">
    <RouterView />

    <!-- Session Timeout Warning Dialog -->
    <SessionTimeoutWarning
      :show="sessionTimeout.isWarningActive.value"
      :time-remaining="sessionTimeout.timeRemainingSeconds.value"
      :warning-duration="sessionTimeout.config.warningDuration"
      @extend-session="handleExtendSession"
      @logout="handleWarningLogout"
    />
  </div>
</template>

<style scoped>
#app {
  font-family: 'Inter', system-ui, sans-serif;
}
</style>
